import axios from 'axios'
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

const playNotificationSound = () => {
  try {
    const audio = new Audio(process.env.PUBLIC_URL + '/media/sounds/notification.wav')
    audio.play().catch(() => undefined)
  } catch (error) {
    return
  }
}

export const requestNotificationPermission = () => {
  if (typeof Notification === 'undefined') return
  if (Notification.permission === 'default') {
    Notification.requestPermission().catch(() => undefined)
  }
}

const buildNotificationContent = (notification: any) => {
  const type = String(notification?.type ?? '').split('\\').pop()

  if (type === 'SaleUnderReview') {
    return {
      title: 'Venda aguardando aprovação',
      body:
        `Nº venda ${notification?.sale_id ?? '---'}` +
        (notification?.franchise_name ? ` - ${notification.franchise_name}` : ''),
      url: notification?.sale_id ? `/sales/list/${notification.sale_id}` : null,
    }
  }

  if (type === 'SaleReviewed') {
    return {
      title: notification?.approved ? 'Venda aprovada' : 'Venda reprovada',
      body:
        `Nº venda ${notification?.sale_id ?? '---'}` +
        (notification?.franchise_name ? ` - ${notification.franchise_name}` : ''),
      url: notification?.sale_id ? `/sales/list/${notification.sale_id}` : null,
    }
  }

  if (type === 'TransferGenerated') {
    return {
      title: 'Transferência aguardando aprovação',
      body: `${notification?.origin_franchise_name ?? '---'} -> ${
        notification?.destination_franchise_name ?? '---'
      }`,
      url: notification?.transfer_id ? `/transfers/list/${notification.transfer_id}` : null,
    }
  }

  return {title: 'Nova notificação', body: '', url: null}
}

const showBrowserNotification = (notification: any) => {
  if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return

  try {
    const {title, body, url} = buildNotificationContent(notification)
    const browserNotification = new Notification(title, {
      body,
      icon: process.env.PUBLIC_URL + '/media/logos/logoLaser.png',
    })

    browserNotification.onclick = () => {
      window.focus()
      if (url) {
        window.location.href = url
      }
      browserNotification.close()
    }
  } catch (error) {
    return
  }
}

export const echoReverb = (userId, setCurrentUser) => {
  window.Pusher = Pusher
  const echo = new Echo({
    broadcaster: 'reverb',
    key: process.env.REACT_APP_REVERB_KEY,
    wsHost: process.env.REACT_APP_REVERB_HOST,
    wsPort: Number(process.env.REACT_APP_REVERB_PORT),
    wssPort: Number(process.env.REACT_APP_REVERB_PORT),
    forceTLS: process.env.REACT_APP_REVERB_TLS == 'true',
    enabledTransports: ['ws', 'wss'],
    authorizer: (channel, options) => {
      return {
        authorize: (socketId, callback) => {
          axios
            .post(process.env.REACT_APP_API_URL + '/broadcasting/auth', {
              socket_id: socketId,
              channel_name: channel.name,
            })
            .then((response) => {
              callback(false, response.data)
            })
            .catch((error) => {
              callback(true, error)
            })
        },
      }
    },
  })

  echo.private('users.' + userId).notification((notification) => {
    playNotificationSound()
    showBrowserNotification(notification)

    const normalized = {
      ...(notification?.data ?? notification),
      id: notification?.id,
      type: notification?.type,
    }

    setCurrentUser((current) => {
      if (!current) return current

      const existing = current.unreadNotifications || []
      if (normalized.id && existing.some((n: any) => n.id === normalized.id)) {
        return current
      }

      return {
        ...current,
        unreadNotifications: [...existing, normalized],
      }
    })
  })

  return echo
}
